import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, Teleport as _Teleport, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createStaticVNode as _createStaticVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "landing-pages"
};
const _hoisted_2 = {
  class: "main-hero static-space-top"
};
const _hoisted_3 = {
  class: "custom-container"
};
const _hoisted_4 = {
  class: "hero-grid"
};
const _hoisted_5 = {
  class: "grid-left"
};
const _hoisted_6 = {
  class: "visit-details"
};
const _hoisted_7 = {
  class: "grid-right"
};
const _hoisted_8 = {
  class: "box-size"
};
const _hoisted_9 = {
  class: "rating-sec"
};
const _hoisted_10 = {
  class: "coverage"
};
const _hoisted_11 = {
  class: "main-hero"
};
const _hoisted_12 = {
  class: "custom-container section-margin"
};
const _hoisted_13 = {
  class: "hero-grid"
};
const _hoisted_14 = {
  class: "grid-right d-flex align-items-center"
};
const _hoisted_15 = {
  class: "box-size"
};
import Rating from "@/components/header/rating";
import FeedbackUpdate from "@/components/header/feedbackUpdate";
import HealthCovers from "@/components/visitor/healthCovers";
import Happnings from "@/components/visitor/happnings";
import WhyG1G from "@/components/visitor/whyG1G";
import HelpBox from "@/components/globalComponent/helpBox";
import { computed } from "vue";
import { useMeta } from "vue-meta";
import PlanFaqs from "@/components/visitor/planFaqs.vue";
import YoutubeSection from "@/components/visitor/youtubeSection.vue";
import PlanCoverage from "@/components/visitor/planCoverage.vue";
import { createNamespacedHelpers } from "vuex-composition-helpers";
import { uuid } from "vue-uuid";
import { track } from "@/analytics/events";
import { toRaw } from "vue";
import CloudinaryImage from "@/components/CloudinaryImage.vue";
import Bugsnag from "@bugsnag/js";
export default {
  __name: 'nomadInsurance',
  setup(__props) {
    const userStore = createNamespacedHelpers("user");
    const itiraStore = createNamespacedHelpers("itira");
    const {
      itira
    } = itiraStore.useState(["itira"]);
    const {
      getCustomerInfo
    } = userStore.useGetters(["getCustomerInfo"]);
    const trackPayload = {
      customer_info: toRaw(getCustomerInfo.value),
      cart_id: itira.value?.itira_uuid ?? null,
      event_id: uuid.v4(),
      event_name: "Itira Welcome"
    };
    const toIteraTravelReasons = () => {
      track("ITIRA - Start", {
        ...trackPayload
      });
      track("Nomad Insurance ITIRA - Start", {
        ...trackPayload
      });
      Bugsnag.leaveBreadcrumb('Button clicked');
      track("Shop All Plans ", {
        customer_info: toRaw(getCustomerInfo.value),
        source: "Nomad Insurance",
        cart_id: itira.value?.itira_uuid ?? null,
        event: uuid.v4()
      });
    };
    useMeta({
      title: "G1G Nomad Insurance",
      meta: [{
        name: 'description',
        content: "Travel the world with confidence with G1G's Nomad Insurance. Comprehensive coverage for global nomads and travelers. Secure your journey today!"
      }, {
        property: 'og:description',
        content: "Travel the world with confidence with G1G's Nomad Insurance. Comprehensive coverage for global nomads and travelers. Secure your journey today!"
      }, {
        property: 'og:title',
        content: "G1G Nomad Insurance"
      }, {
        property: 'og:image',
        content: 'https://g1gv3.s3.us-west-1.amazonaws.com/images/nomad-insurance.png'
      }, {
        property: 'og:url',
        content: `${window.location.origin}/nomad-insurance`
      }, {
        property: 'og:site_name',
        content: 'G1G'
      }, {
        property: 'og:type',
        content: 'website'
      }, {
        property: 'og:locale',
        content: 'en_US'
      }, {
        property: 'og:url',
        content: `${window.location.origin}/nomad-insurance`
      }, {
        name: 'twitter:card',
        content: 'summary'
      }, {
        name: 'twitter:site',
        content: '@G1G_Travel'
      }, {
        name: 'twitter:title',
        content: "G1G Nomad Insurance"
      }, {
        property: 'twitter:description',
        content: "Travel the world with confidence with G1G's Nomad Insurance. Comprehensive coverage for global nomads and travelers. Secure your journey today!"
      }, {
        name: 'twitter:image',
        content: 'https://g1gv3.s3.us-west-1.amazonaws.com/images/nomad-insurance.png'
      }, {
        name: 'twitter:image:alt',
        content: 'G1G Travel & Visitors Insurance, San Jose, CA'
      }],
      link: [{
        rel: 'canonical',
        href: `${window.location.origin}/nomad-insurance`
      }]
    });
    //Faqs
    let questions = [{
      Heading: "What is travel insurance for digital nomads?\n",
      details: [{
        p: "Travel insurance for digital nomads is designed to meet the unique needs of individuals who work remotely while traveling or living abroad. Unlike traditional travel insurance, it provides extended coverage suitable for long-term stays, including health care, emergency evacuation, and equipment protection, ensuring digital nomads can work and explore with peace of mind."
      }]
    }, {
      Heading: "Why do digital nomads need specialized travel insurance?",
      details: [{
        p: "Digital nomads face unique risks from living and working in various countries, such as health issues from changing environments, loss or damage to electronic devices crucial for their work, and the need for flexibility in insurance coverage due to their mobile lifestyle. Specialized travel insurance addresses these specific needs, offering comprehensive protection that standard policies may not cover."
      }]
    }, {
      Heading: "What does travel insurance for digital nomads typically cover?",
      details: [{
        p: "This type of insurance typically includes emergency medical expenses, evacuation and repatriation, coverage for lost or stolen equipment (like laptops and cameras), and sometimes liability insurance. Plans might also offer options for trip interruption, flexible coverage periods, and coverage for activities that nomads might engage in during their travels."
      }]
    }, {
      Heading: "Why is G1G the ideal insurance provider for my nomadic lifestyle?",
      details: [{
        p: "G1G stands out as the perfect match for digital nomads due to their deep understanding of the flexible, mobile lifestyle that defines nomadism. Our policies are designed with the nomad’s unique needs in mind, providing customizable options to fit varied travel plans and work requirements. With G1G, digital nomads gain access to a provider that offers seamless policy management online, exceptional customer service across multiple time zones, and a strong reputation backed by positive feedback from the nomadic community. "
      }]
    }];
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("template", null, [(_openBlock(), _createBlock(_Teleport, {
        to: "head"
      }, [(_openBlock(), _createBlock(_resolveDynamicComponent('script'), {
        type: "application/ld+json"
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [_createTextVNode(" { \"@context\": \"https://schema.org\", \"@graph\": [ { \"@type\": \"Organization\", \"@id\": \"https://www.g1g.com/#organization\", \"name\": \"G1G.com\", \"url\": \"https://www.g1g.com/\", \"logo\": \"https://www.g1g.com/logo.png\", \"location\": { \"@type\": \"Place\", \"address\": { \"@type\": \"PostalAddress\", \"streetAddress\": \"1494 Hamilton Ave STE 101\", \"addressLocality\": \"San Jose\", \"addressRegion\": \"CA\", \"postalCode\": \"95125\", \"addressCountry\": \"USA\" } }, \"founder\": { \"@type\": \"Person\", \"name\": \"Zubair\" }, \"contactPoint\": [ { \"@type\": \"ContactPoint\", \"telephone\": \"+1-408-478-9990\", \"contactType\": \"customer service\" } ] }, { \"@type\": \"BreadcrumbList\", \"itemListElement\": [ { \"@type\": \"ListItem\", \"position\": 1, \"item\": { \"@id\": \"https://www.g1g.com/\", \"name\": \"Home\" } }, { \"@type\": \"ListItem\", \"position\": 2, \"item\": { \"@id\": \"https://www.g1g.com/nomad-insurance\", \"name\": \"G1G Nomad Insurance\" } } ] }, { \"@type\": \"Product\", \"name\": \"G1G Nomad Insurance\", \"image\": [ \"https://www.g1g.com/nomad-insurance-image1.jpg\" ], \"description\": \"Travel the world with confidence with G1G's Nomad Insurance. Comprehensive coverage for global nomads and travelers. Secure your journey today!\", \"brand\": { \"@type\": \"Brand\", \"name\": \"G1G.com\" }, \"offers\": { \"@type\": \"Offer\", \"url\": \"https://www.g1g.com/nomad-insurance\", \"priceCurrency\": \"USD\", \"price\": \"89.99\", \"availability\": \"https://schema.org/InStock\" }, \"aggregateRating\": { \"@type\": \"AggregateRating\", \"ratingValue\": \"4.9\", \"reviewCount\": \"250\" }, \"review\": [ { \"@type\": \"Review\", \"author\": \"Taylor Green\", \"datePublished\": \"2023-09-01\", \"reviewBody\": \"Nomad's insurance from G1G is a lifesaver. Affordable and comprehensive coverage that I can trust during my travels.\", \"reviewRating\": { \"@type\": \"Rating\", \"ratingValue\": \"5\" } } ] } ] } ")])),
        _: 1
      }))]))]), _createElementVNode("div", _hoisted_1, [_createElementVNode("section", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_cache[6] || (_cache[6] = _createElementVNode("h3", {
        class: "headline-3"
      }, "Travel insurance plans designed for wanderlust.", -1)), _createElementVNode("div", _hoisted_6, [_cache[2] || (_cache[2] = _createElementVNode("h4", {
        class: "headline-4"
      }, "Pixel perfect plans for that work wherever your adventure takes you.", -1)), _cache[3] || (_cache[3] = _createElementVNode("h5", {
        class: "headline-5 my-3"
      }, "Proven care. Affordable plans. Accepted everywhere.", -1)), _cache[4] || (_cache[4] = _createElementVNode("h6", {
        class: "headline-6 mb-3 text-uppercase"
      }, "Plans for:", -1)), _cache[5] || (_cache[5] = _createElementVNode("div", {
        class: "list-elements"
      }, [_createElementVNode("ul", null, [_createElementVNode("li", null, "Digital nomads"), _createElementVNode("li", null, "Remote workers"), _createElementVNode("li", null, "Expats"), _createElementVNode("li", null, "and more!")])], -1)), _createElementVNode("div", null, [_createVNode(_component_router_link, {
        class: "btn btn-primary g1g-btn-secondary w-75",
        to: "/itira/travel-reasons",
        onClick: toIteraTravelReasons
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode("Shop all plans! ")])),
        _: 1
      })])])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createVNode(CloudinaryImage, {
        alt: "Nomad traveler lying on a seashore, checking insurance facts and coverage on a laptop dashboard by G1G.",
        class: "img-fluid",
        style: {
          "max-width": "80%"
        },
        imageName: "nomad-insurance-image_j8kpu8.png"
      })])])])])]), _createElementVNode("section", _hoisted_9, [_createVNode(_unref(Rating)), _createVNode(_unref(FeedbackUpdate))]), _createElementVNode("section", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_cache[8] || (_cache[8] = _createElementVNode("div", {
        class: "visit-details"
      }, [_createElementVNode("h2", {
        class: "headline-2"
      }, [_createTextVNode("Here’s how we make "), _createElementVNode("br"), _createTextVNode(" sure you’re covered.")])], -1)), _createElementVNode("div", _hoisted_13, [_cache[7] || (_cache[7] = _createStaticVNode("<div class=\"grid-left\"><div class=\"visit-details\"><h4 class=\"headline-4\">Get an unbiased quote, ridiculously fast, with AI</h4><p class=\"body-5\">Get an instant quote from our super-friendly bot, ITIRA, and easily compare coverage between dozens of vetted providers.</p></div><div class=\"visit-details div1\"><h4 class=\"headline-4\">Connect to the right kind of plan</h4><p class=\"body-5\">ITIRA recommendations a plan specific to you, your trip, and your destination.</p></div><div class=\"visit-details div2\"><h4 class=\"headline-4\">G1G Flex so you can cancel on your terms*</h4><p class=\"body-5\">Shop G1G Flex so you decide when it’s time to travel or time to cancel your trip.</p></div><div class=\"visit-details div3\"><h4 class=\"headline-4\">A dedicated Claims Advocacy team free with every plan</h4><p class=\"body-5\">We help make sure the paperwork is all there, filed correctly, and help the traveler if the claim is wrongfully denied or moving too slow.</p></div><div class=\"visit-details div4\"><h6>*Specific time-sensitive eligibility requirements apply to Cancel for Any Reason plans. Please see specific plan details or get in touch to make sure you can get covered! </h6></div></div>", 1)), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createVNode(CloudinaryImage, {
        alt: "Girl checking detailed weather updates on her device for her nomadic journey, using G1G's services.",
        class: "img-fluid",
        imageName: "nomad-insurance-image1_qcbznb.png"
      })])])])])])]), _createVNode(YoutubeSection, {
        title: "Travel Insurance Explained",
        videoUrl: "https://www.youtube.com/embed/qbmx43zDbPE?si=lu_ZL_0lWVR_ocrF"
      }), _createVNode(PlanCoverage), _createVNode(PlanFaqs, {
        questions: _unref(questions)
      }, null, 8, ["questions"]), _createVNode(_unref(WhyG1G)), _createVNode(_unref(HelpBox))])], 64);
    };
  }
};